import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import { CheckboxInput2023Expects } from "../../../Common";

interface IsBillingAndShippingTheSameFormLogicPureProps {
  ref: React44ms.Api.TypedRef<CheckboxInput2023Expects>;
}
const IsBillingAndShippingTheSameFormLogicPure: React44ms.Api.FunctionComponent<
  IsBillingAndShippingTheSameFormLogicPureProps
> = (props) => {
  const [isBillingAndShippingTheSame, setIsBillingAndShippingTheSame] =
    React44ms.Api.useState(true);
  const handleChange: React44ms.Api.input["onChange"] =
    React44ms.Api.useCallback((event) => {
      setIsBillingAndShippingTheSame(event.target.value);
    }, []);
  const outputValue: CheckboxInput2023Expects = React44ms.Api.useMemo(
    () => ({
      value: isBillingAndShippingTheSame,
    }),
    [isBillingAndShippingTheSame]
  );
  return (
    <form>
      <input React44ms_onChange={handleChange} />
      <output React44ms_value={outputValue} />
    </form>
  );
};

export const IsBillingAndShippingTheSameFormLogic = React44ms.React.Reactify(
  IsBillingAndShippingTheSameFormLogicPure
);
